import { useContext } from "react";
import styled from "styled-components";
import { PageContext } from "../Context/PageContext";



async function OpenPopMenu() {

    let PopMenuObject = await document.getElementById("PopMenuWindow");

    let widthTipBox = await PopMenuObject.getBoundingClientRect().right - PopMenuObject.getBoundingClientRect().left;
    let heightTipBox = await PopMenuObject.getBoundingClientRect().bottom - PopMenuObject.getBoundingClientRect().top
        
    if(window.innerWidth <= 1000) {
        PopMenuObject.style.left = "0px";
    } else {
        PopMenuObject.style.left = window.innerWidth/2 - widthTipBox/2 + "px";
    }
    //PopMenuObject.style.left = window.innerWidth/2 - widthTipBox/2 + "px";

    PopMenuObject.style.top = window.innerHeight/2 - heightTipBox/2 + window.scrollY + "px";

    PopMenuObject.style.opacity = "1";
    PopMenuObject.style.zIndex = "30";

    }

function PopMenuWindow(props) {

    const {popMenuContent, setPopMenuContent} = useContext(PageContext)

        function CancelPopMenu(event) {

            let PopMenuObject = event.target.parentElement;

            PopMenuObject.style.opacity = "0";
            PopMenuObject.style.zIndex = "-1";

    }

    return(
        <PopUpWindowMasterContainer id={props.PopMenuId}>
            <MasterContainer>
                { popMenuContent }
            </MasterContainer>
            <ClosePopUpButton onClick={(e) => {CancelPopMenu(e)}}>Fechar</ClosePopUpButton>
            

        </PopUpWindowMasterContainer>
    )
}

export default PopMenuWindow;
export { OpenPopMenu };



const PopUpWindowMasterContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    padding: 0px 0px;
    z-index: -1;
    opacity: 0;
    border-radius: 10px;
    //background-color: rgba(19, 20, 19, 0.9);
    transition: .3s ease-in-out;
    pointer-events: auto;
    //border: solid;

    @media(max-width: 1000px) {
    scale: 0.5;
    }

`

const ClosePopUpButton = styled.div`
    display: flex;
    bottom: 0;
    align-items: center;
    text-align: center;
    justify-content: center;
    background-color: rgb(145, 17, 17);
    color: white;
    width: 200px;
    height: 50px;
    padding: 0px 5px;
    border-radius: 10px;
    z-index: 11;
    transition: .3s ease-in-out;
    font-size: 14pt;
    pointer-events: auto;
    margin-top: 10px;
    opacity: .7;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

    &:hover {
    filter: saturate(150%);
    opacity: 1;
    scale: 1.1;
    }

`

const MasterContainer = styled.div`
    display: flex;
    //border: solid 1px;
    align-items: center;
    //background-color: white;
    border-radius: 10px;
   //box-shadow: 10px 10px 10px 0 black;
`